// extracted by mini-css-extract-plugin
export var button = "_6w-7";
export var buttonRow = "_6w-6";
export var fadeIn = "_6w-1";
export var gradient = "_6w-0";
export var panel = "_6w-2";
export var panelIn = "_6w-3";
export var subtitle = "_6w-5";
export var title = "_6w-4";